<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.23567 3.18842L3.28591 8.13818C2.11433 9.30975 2.11433 11.2092 3.28591 12.3808C4.45747 13.5524 6.35697 13.5524 7.52854 12.3808L13.4211 6.48825C14.2021 5.70722 14.2021 4.44088 13.4211 3.65982C12.6401 2.87878 11.3737 2.87878 10.5927 3.65982L4.70014 9.55238C4.3096 9.94292 4.3096 10.5761 4.70014 10.9666C5.09064 11.3571 5.7238 11.3571 6.11434 10.9666L11.0641 6.01685"
      stroke="#696D69" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
